













































































































































































































































































































































































































import {Component, Vue} from "vue-property-decorator";
import {Customer} from "@/entity/Customer";
import {getModule} from "vuex-module-decorators";
import {CustomerStore} from "@/store/CustomerStore";
import {AuthStore} from "@/oauth/AuthStore";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {CustomerDto} from "@/dto/CustomerDto";
import {Message} from "@/entity/Message";
import {XMPPStore} from "@/store/XMPPStore";
import {XmppUtils} from "@/xmpp/XmppUtils";
// import {Strophe} from "@/xmpp/Strophe";
import {Strophe} from "strophe.js";
import {Friend} from "@/entity/Friend";
import ChatPage from "@/views/ChatPage.vue";
import {CollectCompany} from "@/entity/CollectCompany";
import {CollectCompanyDto} from "@/dto/CollectCompanyDto";
import {Group} from "@/entity/Group";
import {GroupMessage} from "@/entity/GroupMessage";
import {User} from "@/oauth/User";
import {UserDto} from "@/oauth/UserDto";
import {Notification} from "@/entity/Notification";
import {NotificationDto} from "@/dto/NotificationDto";
import router from "@/router";
import {UserInfoEntity} from "@/entity/UserInfoEntity";
import {UserInfoEntityDto} from "@/dto/UserInfoEntityDto";
import XXHeader from "@/views/KeShangAdmin/XXHeader.vue";
import {KsChatUserDto} from "@/dto/KsChatUserDto";
import {KsChatUser} from "@/entity/KsChatUser";
import {InsertGroup} from "@/entity/InsertGroup";
import {ajax} from "jquery";
import { BpmToDoDoneDto } from "@/dto/BpmToDoDoneDto";
import {BpmToDoDoneEntity} from "@/entity/BpmToDoDoneEntity";

@Component({
  components: {XXHeader, ChatPage},
})


export default class KeShangSelect2 extends Vue {
  private customers: Customer[] = [];
  customer = new Customer();
  collectCompany = new CollectCompany()
  demo: UserInfoEntity[] = []
  isAdminOpen = false;
  cs = getModule(CustomerStore);
  ls = getModule(AuthStore);
  co = getModule(XMPPStore);
  su = SecurityUtils;
  rightDrawerOpen = true;
  drawer = false;
  tab = 'mails';
  tab2 = 'all';
  groups: Group[] = XmppUtils.groups;
  friends: Friend[] = XmppUtils.friends;
  static recentlyFriends: Friend[] = [];
  recentlyFriends = KeShangSelect2.recentlyFriends;
  connection!: Strophe.Connection;
  friendName = '';
  notifications: Notification[] = [];
  unreadNotifications: Notification[] = [];
  unreadNotifications1: BpmToDoDoneEntity[] = [];
  readedNotifications: Notification[] = [];
  creatGroupDialog = false;
  text = '';
  dialog = false;
  insertGroup = new InsertGroup();

  message1 = new Message();
  items = ([{}, {}, {}, {}, {}, {}, {}, {}, {}])

  async creatGroup() {
    this.insertGroup.managerId = this.su.getLoginUser().username;
    this.insertGroup.managerName = this.su.getLoginUser().name;
    this.insertGroup.ksChatuserList.push(this.su.getLoginUser().username + '@rtc1');
    // this.insertGroup.roomName = this.insertGroup.groupName;
    this.friends.forEach(value => {
      if (value.isSelect) {
        this.insertGroup.ksChatuserList.push(value.jid);
      }
    })
    console.log(this.insertGroup);
    const a = await KsChatUserDto.insertGroup(this.insertGroup);
    console.log(a);
    this.creatGroupDialog = false;
    // const xmppUtils = new XmppUtils();
    // await xmppUtils.xmppLogin();
    // this.refresh();
    await window.location.reload();
  }

  handleButtonSelected() {
    if (this.$refs.selectFiles != null) {
      (this.$refs.selectFiles as any).click()
    }
  }

  uploadIt() {
    this.handleButtonSelected();
  }

  handlerUpload(e: any) {
    const files = e.target.files[0] //当input中选择文件时触发一个事件并让data当中的files拿到所选择的文件
    const formData = new FormData();
    formData.append("file", files);
    formData.append("system", 'customer');
    ajax({
      type: 'POST',
      url: "https://fileserver.yong-gang.cn/api/uploadFile",
      dataType: 'json',
      data: formData,
      processData: false,   // jQuery不要去处理发送的数据
      contentType: false,  // jQuery不要去设置Content-Type请求头
      success: (data: any) => {
        this.insertGroup.headPortrait = data.data.filePreviewUrl;
      },
      timeout: 5000,
      error: () => {
        console.log('出错了');
      }
    })
  }

  searchFriend() {
    this.friends = XmppUtils.friends;
    if (this.friends.length == 0) {
      const friendList = window.localStorage.getItem("friendList");
      if (friendList != null && friendList.length > 2) {
        this.friends = JSON.parse(friendList)
      }
    } else {
      const friends = this.friends.filter(v => v.name.toLowerCase().indexOf(this.friendName) > -1);
      this.friends = friends;
    }
  }


  refresh() {
    setTimeout(() => {
      // this.$router.push({name: 'refresh'})
      location.reload();
    }, 500)
  }


  // async getAvatarUrl(name: string) {
  //   const user = new User();
  //   user.name = name;
  //   user.avatarUrl = "https://cdn.quasar.dev/img/avatar2.jpg";
  //
  //   const users = await UserDto.findByUsername(name.substring(0, 11));
  //   console.log(users);
  //   if (users) {
  //     console.log(users.avatarUrl);
  //     return users.avatarUrl;
  //   }else {
  //     return user.avatarUrl;
  //   }
  //
  // }

  getUnReadNumber(jid: string) {
    const item = localStorage.getItem(this.su.getLoginUser().username + 'messages' + jid.substring(0, 11));
    if (item != null && item.length > 2) {
      let messages: Message[] = [];
      const messages1: Message[] = [];
      messages = JSON.parse(item);
      messages.forEach(value => {
        if (!value.isRead && value.isSent === 'received') {
          messages1.push(value);
        }
      })
      return messages1.length;
    }
    return 0;
  }

  getMessage(jid: string) {
    const item = localStorage.getItem(this.su.getLoginUser().username + 'messages' + jid.substring(0, 11)) as string;
    if (item != null && item.length > 2) {
      let messages: Message[] = [];
      messages = JSON.parse(item);
      return messages[messages.length - 1];
    }
    const message1 = new Message();
    message1.time = '';
    return message1;
  }

  getGroupMessage(name: string) {
    const item = localStorage.getItem(this.su.getLoginUser().username + 'groupMessages' + name);
    if (item != null && item.length > 2) {
      let groupMessages: GroupMessage[] = [];
      groupMessages = JSON.parse(item);
      return groupMessages[groupMessages.length - 1];
    }
    const groupMessage1 = new GroupMessage();
    groupMessage1.time = '';
    return groupMessage1;
  }

  keShangSelect() {
    this.$router.push({name: 'KeShangSelect'});
  }

  keShangSelect1() {
    this.$router.push({name: 'keShangSelect1'});
  }

  keShangSelect2() {
    this.$router.push({name: 'keShangSelect2'}).catch(err => err);
  }


  async save(d: Customer) {
    try {
      await CustomerDto.save(d);
      this.$q.notify('保存成功!');
    } catch (e) {
      this.$q.notify({message: '错误:' + e, color: 'red'});
    }
  }

  public get columns() {
    let columns = Customer.getColumns();
    columns.push({
      label: ' ',
      name: 'edit',
      field: '',
    });
    columns = columns.filter(value => !['creatorId', 'isReviewPass'].some(s => value.name === s));
    return columns;
  }

///
  async getId(id = this.id) {
    this.customer = await CustomerDto.findById(Number(id));
  }

  goToZiZhangHaoGuanLi() {
    this.$router.push({name: 'ZiZhangHao'});
  }

  get id() {
    return this.$route.params.id as string;
  }

  get customerName() {
    // return this.cs.currentCustomer.name;
    return this.collectCompany.companyName;
  }

  // async saveBank() {
  //   const customerBank1 = new CustomerBank();
  //   this.customer.customerBankList.push(customerBank1);
  // }
  // saveCompany() {
  //   localStorage.setItem("name", this.cs.currentCustomer.name)
  // }

  // companyName() {
  //   const item: string | null = localStorage.getItem("name");
  //   console.log(item);
  //   if (item == null) {
  //     return "home"
  //   }
  //   return item;
  // }

  get userName() {
    return this.ls.loginUser.username
  }

  toggleRightDrawer() {
    this.rightDrawerOpen = !this.rightDrawerOpen;
  }

  async findAll() {
    const id = this.su.getLoginUser().id as number;
    const customer = new Customer();
    customer.creatorId = id;
    this.customers = await CustomerDto.findAll(customer);
    for (const value of this.su.getLoginUser().authorities) {
      if (value.authority.startsWith('ROLE_CUSTOMER_')) {
        const id = Number(value.authority.replace('ROLE_CUSTOMER_', '').replace('_ADMIN', ''));
        if (!this.customers.some(c => c.id === id)) {
          const customer = await CustomerDto.findById(id);
          if (typeof customer !== 'undefined') {
            this.customers.push(customer);
          }
        }
      }
    }
  }

  async findAllCompanyName() {
    // const  id = this.su.getLoginUser().id as number;
    // const  collectName = new  CollectCompany()
    // collectName.userId = id;
    // this.collectCompanys = await  CollectCompanyDto.findAll(collectName)
    // console.log(this.collectCompanys)
    // return this.collectCompanys.push(this.collectCompany)

    // const  collectName = await CollectCompanyDto.findById(id)

    const id = this.su.getLoginUser().id as number;
    // const  collectName = new  CollectCompany();
    this.collectCompany = await CollectCompanyDto.findById(id)
    // console.log(this.collectCompany)
    // this.collectCompany.companyName = this.module.currentCustomer.name
  }

  // suc() {
  //   AuthTokenDto.logout();
  //   this.$router.push({name: 'login'});
  // }
  private module: CustomerStore = getModule(CustomerStore);

  handleClick(c: Customer) {
    this.module.setCurrentCustomer(c);
    // getModule(CustomerStore).setCurrentCustomer(c);


    // this.collectCompany.userId =
    this.collectCompany = new CollectCompany()
    this.collectCompany.userName = this.ls.loginUser.username
    // console.log(this.collectCompany.userName)
    this.collectCompany.userId = this.ls.loginUser.id
    this.collectCompany.companyName = c.name
    this.collectCompany.customerAppId = c.id
    this.collectCompany.isReviewPass = c.isReviewPass
    CollectCompanyDto.save(this.collectCompany)

    // console.log(this.collectCompany)


    this.rightDrawerOpen = !this.rightDrawerOpen;

    // this.saveCompany();
    //const id = c.id + '';
    //this.$router.push({name: 'KeShangMain', params: {id: id}});
  }

  async findAllNotifications() {
    const  bpmToDo = await BpmToDoDoneDto.getBpmToDoDone(this.ls.loginUser.username) as any
    console.log(bpmToDo.data.list)
    const notification = new Notification();
    notification.userId = SecurityUtils.getLoginUser().username as unknown as number;
    this.notifications = await NotificationDto.findAll(notification);
    this.unreadNotifications = this.notifications.filter(value => value.isRead !== true);
    this.unreadNotifications1 = bpmToDo.data.list
    this.unreadNotifications = this.unreadNotifications.filter(value => value.qingAppName != "客商审批");
    this.readedNotifications = this.notifications.filter(value => value.isRead === true);
  }

  private async mounted() {
    // this.findAll().then(value => {
    //   this.tab = this.companyName();
    //   const find = this.customers.find(c => c.name === this.tab);
    //   if (find !== undefined) {
    //     this.handleClick(find);
    //   }
    //   this.tab = 'mails';
    // });
    await this.findAll();
    await this.searchFriend();
    // this.findAllCompanyName();
    await this.findAllNotifications();
    const a = localStorage.getItem(XmppUtils.username + 'recentlyFriends');
    if (a != null && a.length > 2) {
      this.recentlyFriends = KeShangSelect2.recentlyFriends = JSON.parse(a);
    }
  }
}
